export default "__VITE_ASSET__dvCaElR0__"